import React, {useCallback, useEffect, useState} from 'react'
import Workspace from "components/Workspace";
import DemandOffersService from "services/DemandOffersService";
import {connect} from 'react-redux'
import Loading from "components/Loading";
import RouterPath from "libs/RouterPath";
import {StageSections, StageSectionsUrlParams} from "./constants/StageSections";
import ContractorClock from "./components/ContractorClock";
import OfferTilesRow from "./components/OfferTilesRow";
import OfferSections from "./components/OfferSections";
import Typography from "components/BoldTypography";
import Tr from "translations/Translations";
import GridBlock from "components/GridBlock";
import {makeStyles} from "@material-ui/styles";
import {OfferStageTranslationsContextProvider} from "../../../../../context/OfferStageTranslationsContext";

const useStyle = makeStyles(theme => ({
    root: {},
    infoMsg: {
        marginBottom: theme.spacing(2),
        cursor: "pointer",
        color: theme.palette.primary.main,
    }
}))

function CtrOfferPanel(
    {
        match,
        demandStagesList,
        demandStageSectionsList
    }) {

    const classes = useStyle();
    const [stageTranslations, setStageTranslations] = useState(null);
    const demandId = match.params.id;
    const stageId = match.params.stageId;

    const [dashboardSection, setDashboardSection] = useState(null);

    useEffect(() => {
        if (demandStagesList) {
            if (!stageId) {
                const href = RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID, {
                    id: demandId,
                    stageId: demandStagesList[demandStagesList.length - 1].identity
                });
                RouterPath.redirectWithoutHistory(href);
            }
        }
        // eslint-disable-next-line
    }, [demandStagesList, stageId])

    useEffect(() => {
        if (demandStageSectionsList)
            setDashboardSection(demandStageSectionsList[StageSections.DASHBOARD]);

    }, [demandStageSectionsList]);

    useEffect(() => {
        if (stageId) {
            DemandOffersService.getStageSections(demandId, stageId);
            DemandOffersService.getStageTranslations(demandId, stageId).then(resp => setStageTranslations(resp))
        }
        return () => {
            setStageTranslations(null);
            DemandOffersService.clearResources(DemandOffersService.DEMAND_STAGE_SECTIONS_LIST);
        }
    }, [demandId, stageId])

    const getStageTranslation = useCallback((trKey) => {
        return stageTranslations[trKey] || trKey;
    }, [stageTranslations])

    return (
        <>
            {(!demandStagesList || !demandStageSectionsList || !dashboardSection || !stageTranslations) ? <Loading/> :
                <OfferStageTranslationsContextProvider value={getStageTranslation}>
                    <Workspace
                        render={<>
                            <ContractorClock endTimeCallback={() => DemandOffersService.getStageSections(demandId, stageId)}
                                             dashboardSection={dashboardSection}/>


                            {!!demandStageSectionsList[StageSections.OFFER_EDIT]?.offerOutOfDateDueToRfxModification &&
                            <GridBlock justify="center">
                                <Typography className={classes.infoMsg}
                                            onClick={() => RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID_SECTION, {
                                                id: demandId,
                                                stageId: stageId,
                                                section: StageSectionsUrlParams.OFFER_EDIT
                                            }))}>{Tr('general_info_offer_outdated_due_to_modification')}</Typography>
                            </GridBlock>
                            }

                            {!!demandStageSectionsList[StageSections.GENERAL_INFO]?.unreadDemandDocuments &&
                            <GridBlock justify="center">
                                <Typography className={classes.infoMsg}
                                            onClick={() => RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID_SECTION, {
                                                id: demandId,
                                                stageId: stageId,
                                                section: StageSectionsUrlParams.GENERAL_INFO
                                            }))}>{Tr('general_info_order_documents_new_notification')}</Typography>
                            </GridBlock>
                            }

                            {!!demandStageSectionsList[StageSections.GENERAL_INFO]?.unreadRfxMessages &&
                            <GridBlock justify="center">
                                <Typography className={classes.infoMsg}
                                            onClick={() => RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID_SECTION, {
                                                id: demandId,
                                                stageId: stageId,
                                                section: StageSectionsUrlParams.GENERAL_INFO
                                            }))}>{Tr('general_info_answer_on_question_new_notification')}</Typography>
                            </GridBlock>
                            }
                            <OfferTilesRow dashboardSection={dashboardSection} demandStageSectionsList={demandStageSectionsList}/>
                            <OfferSections demandStageSectionsList={demandStageSectionsList}/>
                        </>}
                    />
                </OfferStageTranslationsContextProvider>
            }
        </>
    )
}


export default connect((state) => ({
    demandStagesList: state.resources[DemandOffersService.DEMAND_STAGES_LIST],
    demandStageSectionsList: state.resources[DemandOffersService.DEMAND_STAGE_SECTIONS_LIST]
}), {})(CtrOfferPanel)